// Duplicate necessary parts for Cypress debug exposure
declare global {
  interface Window {
    Cypress?: unknown;
    cypressDebug?: unknown; // Simplified to avoid duplicating complex interface
    exposeForCypress?: (iframeWindow: Window) => void;
  }
  var cypressDebug: unknown;
}

export function isCypressEnvironment(): boolean {
  return globalThis.window !== undefined && !!globalThis.Cypress;
}

export function exposeForCypress(iframeWindow: Window): void {
  if (!isCypressEnvironment()) {
    return;
  }
  globalThis.cypressDebug = iframeWindow.cypressDebug;
}

// Make the function available on the global window object for iframe access
globalThis.exposeForCypress = exposeForCypress;